import React from "react";
import { Link } from "react-router-dom";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import "../../styles/helpStart.css";
import { useTranslation } from "react-i18next";

import { useSidebar } from "../../App";

import {
  HiOutlineCpuChip,
  HiOutlineDocumentText,
  HiOutlineShieldCheck,
  HiOutlinePlay,
  HiOutlineChartBar,
} from "react-icons/hi2";

export default function HelpStart() {
  const { t } = useTranslation("help");

  const { sidebarCollapsed } = useSidebar();

  const steps = [
    {
      step: 1,
      icon: <HiOutlineCpuChip />,
      title: t("howToStart.steps.step1.title"),
      desc: t("howToStart.steps.step1.desc"),
      path: "/endpoints",
    },
    {
      step: 2,
      icon: <HiOutlineDocumentText />,
      title: t("howToStart.steps.step2.title"),
      desc: t("howToStart.steps.step2.desc"),
      path: "/generate",
    },
    {
      step: 3,
      icon: <HiOutlineShieldCheck />,
      title: t("howToStart.steps.step3.title"),
      desc: t("howToStart.steps.step3.desc"),
      path: "/profiles",
    },
    {
      step: 4,
      icon: <HiOutlinePlay />,
      title: t("howToStart.steps.step4.title"),
      desc: t("howToStart.steps.step4.desc"),
      path: "/status",
    },
    {
      step: 5,
      icon: <HiOutlineChartBar />,
      title: t("howToStart.steps.step5.title"),
      desc: t("howToStart.steps.step5.desc"),
      path: "/reports",
    },
  ];

  return (
    <div className="theme-whbl">
      <div className="container-fluid">
        <div className="main-container">
          <main
            className={`${sidebarCollapsed ? "col-11" : "col-10"}`}
            style={{ width: "100%", overflowX: "auto" }}
          >
            <div className="dashboard">
              <div className="pm-header">
                <h1 className="pm-title">{t("howToStart.title")}</h1>
              </div>

              <div className="help-steps">
                {steps.map((item, index) => (
                  <React.Fragment key={item.step}>
                    <Link
                      to={item.path}
                      className="help-step-card"
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      <div className="help-step-icon">{item.icon}</div>

                      <div className="help-step-content">
                        <h3>
                          Step {item.step}: {item.title}
                        </h3>

                        <p>{item.desc}</p>
                      </div>
                    </Link>

                    {index !== steps.length - 1 && (
                      <div className="help-arrow">
                        <HiOutlinePlay
                          style={{
                            transform: "rotate(90deg)",
                            color: "#0b3d91",
                            fontSize: "24px",
                          }}
                        />
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>

              {/* Internal CSS */}
              <style>{`
                .help-steps{
                    display:flex;
                    flex-direction:column;
                    gap:10px;
                    margin-top:30px;
                }

                .help-step-card{
                    display:flex;
                    align-items:center;
                    gap:20px;
                    padding:22px;
                    background:#fff;
                    border:1px solid #e5e7eb;
                    border-radius:14px;
                    transition:.3s;
                    box-shadow:0 2px 10px rgba(0,0,0,.05);
                }

                .help-step-card:hover{
                    transform:translateY(-3px);
                    box-shadow:0 10px 25px rgba(0,0,0,.12);
                    border-color:#0b3d91;
                }

                .help-step-icon{
                    width:70px;
                    height:70px;
                    min-width:70px;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    background:#f4f8ff;
                    color:#0b3d91;
                    border:2px solid #dbeafe;
                    border-radius:16px;
                    font-size:36px;
                    transition:.3s;
                }

                .help-step-card:hover .help-step-icon{
                    background:#0b3d91;
                    color:#fff;
                    transform:scale(1.08);
                }

                .help-step-content h3{
                    margin:0;
                    font-size:20px;
                    color:#0f172a;
                    font-weight:600;
                }

                .help-step-content p{
                    margin-top:8px;
                    color:#475569;
                    line-height:1.6;
                    font-size:15px;
                }

                .help-arrow{
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    margin:5px 0;
                }

                @media(max-width:768px){

                    .help-step-card{
                        flex-direction:column;
                        text-align:center;
                    }

                    .help-step-content h3{
                        font-size:18px;
                    }

                    .help-step-icon{
                        width:60px;
                        height:60px;
                        min-width:60px;
                        font-size:30px;
                    }
                }
              `}</style>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}